import { WorksheetPricingMode } from "generated/graphql";
import formatCentsToUSD from "utils/money/formatCentsToUSD";

type PricingStatusInput = {
  pricingMode: WorksheetPricingMode;
  pricingOverrideField?: string | null;
  profitCents: number;
  marginPercentage: number | null;
};

export const worksheetPricingStatus = ({
  pricingMode,
  pricingOverrideField,
  profitCents,
  marginPercentage,
}: PricingStatusInput): string => {
  if (pricingMode === WorksheetPricingMode.RATE) {
    return "Selling price entered manually";
  }

  if (pricingMode === WorksheetPricingMode.FIXED) {
    return "Total entered manually";
  }

  if (pricingOverrideField === "profit") {
    return `Profit target: ${formatCentsToUSD(profitCents)} — price follows costs`;
  }

  if (pricingOverrideField === "margin" && marginPercentage !== null) {
    return `Margin target: ${marginPercentage}% — price follows costs`;
  }

  return "Price follows costs";
};
